import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

import LinkCard from '../general/LinkCard';
import CollapsibleItem from '../general/CollapsibleItem.js';
import CollapsibleGroup from '../general/CollapsibleGroup.js';

function Home(props) {
  const { auth } = props;

  if (!auth.uid) return <Redirect to="/signin" />;

  const cardLevels = () => {
    return <LinkCard title="Admin Levels" actionText="Levels" link="levels" />;
  };

  const cardProfiles = () => {
    return <LinkCard title="Admin Profiles" actionText="Profiles" link="profiles" />;
  };

  const cardDownloadProfiles = () => {
    return <LinkCard title="Download Profiles" actionText="Download Profiles" link="downloadProfiles" />;
  };

  const cardSignupProfilesDailyReport = () => {
    return <LinkCard title="Sign Up Daily Report" actionText="Download Report" link="signupDailyReport" />;
  };

  const cardInviteCodes = () => {
    return <LinkCard title="Admin InviteCodes" actionText="InviteCodes" link="codes" />;
  };

  const cardTemporarySnapshot = () => {
    return <LinkCard title="Temporary snapshots" actionText="Go to export" link="exportSnapshots" />;
  };

  const cardWaitListConfig = () => {
    return <LinkCard title="Wait List Config" actionText="Wait List Config" link="waitListConfig" />;
  };

  const cardIncompleteProfiles = () => {
    return <LinkCard title="Incomplete Profiles" link="incompleteProfiles" />;
  };

  const cardCompanies = () => {
    return <LinkCard title="Admin Companies" actionText="Companies" link="companies" />;
  };

  const cardPlacesSearch = () => {
    return <LinkCard title="Admin PlacesSearch" actionText="PlacesSearch" link="places" />;
  };

  const cardPyns = () => {
    return <LinkCard title="Admin Pyns" actionText="Pyns" link="pyns" />;
  };

  const cardContests = () => {
    return <LinkCard title="Admin Contests" actionText="Contests" link="allContest" />;
  };

  const cardContestEntries = () => {
    return <LinkCard title="Admin Contests Entries" actionText="Contests Entries" link="contestMenu" />;
  };

  const cardWeeklyMissions = () => {
    return <LinkCard title="Admin Weekly Missions" actionText="Weekly Missions" link="weeklyMissionsMenu" />;
  };

  const cardQuestions = () => {
    return <LinkCard title="Admin Questions" actionText="Questions" link="adminQuestions" />;
  };

  const cardSafetyBadges = () => {
    return <LinkCard title="Safety Badges" actionText="Badges" link="badges" />;
  };

  const cardDatabases = () => {
    return <LinkCard title="Admin Databases" actionText="Databases" link="databases" />;
  };

  const cardPrizes = () => {
    return <LinkCard title="Admin Prizes" actionText="Prizes" link="prizesMenu" />;
  };

  const cardFunctions = () => {
    return <LinkCard title="Functions" actionText="Functions" link="functions" />;
  };

  const cardMigrations = () => {
    return <LinkCard title="Migrations" actionText="Migrations" link="migrations" />;
  };

  const cardActivities = () => {
    return <LinkCard title="Activities" actionText="Activities" link="activities" />;
  };

  const cardNotifications = () => {
    return <LinkCard title="Notifications" actionText="Notifications" link="notifications" />;
  };

  const cardUserInbox = () => {
    return <LinkCard title="User Inbox" actionText="User Inbox" link="userInbox" />;
  };

  const cardMessageTemplates = () => {
    return <LinkCard title="Message Templates" actionText="Message Templates" link="messageTemplates" />;
  };

  const sectionProfiles = () => {
    return (
      <CollapsibleItem
        title="Profiles"
        icon="people"
        innerContent={() => {
          return (
            <div className="row">
              {cardProfiles()}
              {cardInviteCodes()}
              {cardLevels()}
              {cardTemporarySnapshot()}
              {cardWaitListConfig()}
              {cardDownloadProfiles()}
              {cardIncompleteProfiles()}
              {cardSignupProfilesDailyReport()}
            </div>
          );
        }}
      />
    );
  };

  const sectionTryps = () => {
    return (
      <CollapsibleItem
        title="Tryps"
        icon="directions_car"
        innerContent={() => {
          return (
            <div className="row">
              {cardCompanies()}
              {cardPyns()}
              {cardPlacesSearch()}
            </div>
          );
        }}
      />
    );
  };

  const sectionChallenges = () => {
    return (
      <CollapsibleItem
        title="Challenges"
        icon="flag"
        innerContent={() => {
          return (
            <div className="row">
              {cardQuestions()}
              {cardWeeklyMissions()}
              {cardContests()}
              {cardContestEntries()}
            </div>
          );
        }}
      />
    );
  };

  const sectionHome = () => {
    return (
      <CollapsibleItem
        title="Home"
        icon="home"
        innerContent={() => {
          return <div className="row">{cardSafetyBadges()}</div>;
        }}
      />
    );
  };

  //TODO: uncomment after implementing score section
  /* const sectionScore = () => {
    return <CollapsibleItem
      title="Score"
      icon="palette"
      innerContent={() => {
        return (
          <div className="row">
            
          </div>
        )
      }} />
  } */

  const sectionMasterAdminTools = () => {
    return (
      <CollapsibleItem
        title="Master Admin Tools"
        icon="settings"
        innerContent={() => {
          return (
            <div className="row">
              {cardDatabases()}
              {cardFunctions()}
              {cardMigrations()}
            </div>
          );
        }}
      />
    );
  };

  const sectionRewards = () => {
    return (
      <CollapsibleItem
        title="Rewards"
        icon="card_giftcard"
        innerContent={() => {
          return <div className="row">{cardPrizes()}</div>;
        }}
      />
    );
  };

  const sectionInbox = () => {
    return (
      <CollapsibleItem
        title="Inbox"
        icon="inbox"
        innerContent={() => {
          return (
            <div className="row">
              {cardNotifications()}
              {cardUserInbox()}
              {cardMessageTemplates()}
              {cardActivities()}
            </div>
          );
        }}
      />
    );
  };

  const renderCollapsibleGroup = () => {
    return (
      <CollapsibleGroup
        innerItems={() => {
          return (
            <React.Fragment>
              {sectionHome()}
              {sectionInbox()}
              {/*sectionScore()*/}
              {sectionTryps()}
              {sectionChallenges()}
              {sectionRewards()}
              {sectionProfiles()}
              {sectionMasterAdminTools()}
            </React.Fragment>
          );
        }}
      />
    );
  };

  return (
    <div className="container">
      <div className="title-section">Dashboard</div>
      {renderCollapsibleGroup()}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(Home);
